// services/apollo.js
import axiosInstance from './axiosInstance';

const APOLLO_API_URL = '/apollo';

const apolloService = {
  async getSync(idempresa) {
    try {
      const response = await axiosInstance.get(`${APOLLO_API_URL}/sync/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter sincronização Apollo:', error);
      return {};
    }
  },

  async performSync(idempresa, warehouses) {
    try {
      const response = await axiosInstance.post(`${APOLLO_API_URL}/sync/perform.php`, {
        idempresa,
        warehouses
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao executar sincronização Apollo:', error);
      throw error;
    }
  },

  async syncTaxes(taxesData) {
    try {
      const response = await axiosInstance.post(`${APOLLO_API_URL}/sync/taxes.php`, taxesData);
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar taxas Apollo:', error);
      throw error;
    }
  },

  async syncSeries(syncData) {
    try {
      const response = await axiosInstance.post(`${APOLLO_API_URL}/sync/series.php`, syncData);
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar séries Apollo:', error);
      throw error;
    }
  }
};

export default apolloService;
